import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { LicenseInfo } from '@mui/x-license';
import { Provider } from 'react-redux';
import store, { persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './globalStyles/picker.scss';
import './globalStyles/hypertrackerChartStyles.scss';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { BasedMiniAppProvider as MiniAppProvider } from '@basedone/miniapp-sdk/react';

const container = document.getElementById('root');
// @ts-ignore
const root = createRoot(container);

LicenseInfo.setLicenseKey(import.meta.env.REACT_APP_MUI || '');

root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <I18nextProvider i18n={i18n}>
                <MiniAppProvider
                    config={{
                        appId: 'hypertracker',
                        debug: import.meta.env.REACT_APP_ENVR === 'dev',
                        name: 'HyperTracker',
                        url: 'https://miniapp.coinmarketman.com',
                        permissions: ['read_navigation'],
                    }}
                >
                    <App />
                </MiniAppProvider>
            </I18nextProvider>
        </PersistGate>
    </Provider>,
);

// Preventing logs on the prod
function noop() {}

// if (import.meta.env.REACT_APP_ENVR !== 'dev') {
//     console.log = noop;
//     console.info = noop;
// }
